module.exports = __webpack_public_path__ + "static/media/Памятка покупателю русский язык.3162f5e4.pdf";